import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { OGPATHS } from 'src-befor/app-routing.module';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { RouterService } from 'src/app/shared/services/router.service';

@Component({
  selector: 'app-search-product',
  templateUrl: './search-product.component.html',
  styleUrls: ['./search-product.component.css'],
})
export class SearchProductComponent implements OnInit {
  searchTerm = '';
  private searchTerm$ = new Subject<string>(); // Pour le debounceTime (delai lors de la saisie)

  autocompleteList: any[] = [];
  listIsDisabled = false;

  @Output()
  result: EventEmitter<any> = new EventEmitter(); // Attribuer un type lorsque la req d'autocomplete sera opérationnelle

  @ViewChild('searchContainer') searchContainer: ElementRef;

  triggerClickEvent() {
    this.searchContainer.nativeElement.click();
  }

  constructor(
    private dynamicDocumentService: DynamicDocumentService,
    private elRef: ElementRef,
    private router: Router,
    private routerService: RouterService
  ) {
    this.setSearchPipe();
  }

  ngOnInit(): void { }

  setSearchPipe() {
   
    this.searchTerm$
      .pipe(
        debounceTime(300), // 300ms delay
        distinctUntilChanged()
      )
      .subscribe((searchTerm: string) => {
        if (searchTerm) {
          this.autocomplete(searchTerm);
        } else {
          this.autocompleteList = [];
        }
      });
  }

  onSearchInput(): void {
    this.searchTerm$.next(this.searchTerm);
  }

  autocomplete(term: string) {
    if (term.length >= 3) {
      this.dynamicDocumentService.find({
        collectionName: 'dynamic_product',
        filters: [{ fieldName: 'referenceProduct', conditions: [{ type: 'CONTAINS', value: term }] },
        { fieldName: 'gencodeProduct', conditions: [{ type: 'CONTAINS', value: term }] },
        { fieldName: 'statusProduct', conditions: [{ type: 'EQUALS', value: 'VALIDE' }] },],
        sorts: {},
        page: 1,
        pageSize: 5,
      }, true).subscribe((res: any) => {
        this.autocompleteList = res.content;
      })
    }
  }

  disableList() {
    this.listIsDisabled = true;

    setTimeout(() => {
      this.listIsDisabled = false;
    }, 1000);
  }

  selectItem(item: any) {
    this.router.navigate([this.routerService.getTranslatedRoute(`/${OGPATHS.product}/${item.referenceProduct ? item.referenceProduct.split(' ').join('_') : item.id}`)]);
    this.autocompleteList = [];
  }

  @HostListener('document:click', ['$event.target'])
  onClickOutsideDiv(targetElement: HTMLElement) {
    const clickedInside = this.elRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      // trigger click event here
      //
      this.autocompleteList = [];
    }
  }
}
